import { useQuery } from '@tanstack/react-query';

import { usePermissions } from '@nucleus-commerce/admin-kit/permissions';

import { storeQueryOptions } from '@/features/stores';

/**
 * The locales an article may be pinned to: the store's supported locales from the store detail
 * (needs `stores.read`), or just the default locale while that loads or without the permission.
 */
export function useStoreLocales(storeId: string, defaultLocale: string): string[] {
  const { can } = usePermissions();
  const query = useQuery({
    ...storeQueryOptions(storeId),
    enabled: can('stores.read'),
    throwOnError: false,
    meta: { silentError: true },
  });
  const supported = query.data?.supportedLocales;
  return supported && supported.length > 0 ? supported : [defaultLocale];
}
